import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import './App.css';
import Catalogue from './home/artwork/Catalogue';
import Estate from './home/Estate';
import Footer from './home/Footer';
import Imprint from './home/Imprint';
import Nav from './home/Nav';
import PageNotFound from "./home/PageNotFound";
import Contact from './home/Contact';
import News from './home/News';
import ArtworkDetails from './home/artwork/ArtworkDetails';
import Biography from './home/bio/Biography';

function App() {

  if (window.location.pathname.match(/^\/$/g) || window.location.pathname.match(/^\/en\/?$/g)) {
    window.location.pathname = '/en/estate';
  } else if (window.location.pathname.match(/^\/en\/?$/g)) {
    window.location.pathname = '/de/estate';
  } else if (window.location.pathname.match(/^\/\w*\/?$/g)) {
    window.location.pathname = '/en/estate';
  }

  return (
    <div id="app">
      <Router>
        <Nav />
        <Switch>
          <Route path="/:lang/artwork/:id" component={ArtworkDetails} />
          <Route path="/:lang/biography" component={Biography} />
          <Route path="/:lang/catalogue" component={Catalogue} />
          <Route path="/:lang/contact" component={Contact} />
          <Route path="/:lang/imprint" component={Imprint} />
          <Route path="/:lang/news" component={News} />
          <Route path="/:lang/estate" component={Estate} />
          <Route path="/" component={PageNotFound} />
        </Switch>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
